import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import filteredObjectsSelector from 'functions/filteredObjectsSelector'
import { objectsToArray } from 'functions/utilities'

import * as campaignProposalActions from 'agency/redux/modules/campaignProposal'

import RealhubFooter from 'components/RealhubFooter'

import BuyerProfiles from './BuyerProfiles'
import CampaignQuotes from './CampaignQuotes'
import Comparables from './Comparables'
import Contact from './Contact'
import Download from './Download'
import Header from './Header'
import KeyFeatures from './KeyFeatures'
import PriceRecommendation from './PriceRecommendation'
import Timeline from './Timeline'
import ToggleableSection from './ToggleableSection'
import Welcome from './Welcome'
import styles from './styles.scss'

const filterComparables = (campaignComparables, source) => {
  const array = objectsToArray(campaignComparables)
  return array.filter(comparable => comparable.comparable_source === source)
}

const disabledSections = (campaignProposal) => {
  if (campaignProposal.options && campaignProposal.options.disabled_sections){
    return campaignProposal.options.disabled_sections
  }

  return []
}

class RealhubMobile extends Component {
  _toggleSection = (sectionId) => {
    const {
      campaignProposal: { id, options },
      updateCampaignProposal,
    } = this.props

    const updatedOptions = options ? Object.assign({}, options) : {}
    const disabled = updatedOptions.disabled_sections || []

    const index = disabled.indexOf(sectionId)
    if (index === -1){
      disabled.push(sectionId)
    } else {
      disabled.splice(index, 1)
    }

    updatedOptions.disabled_sections = disabled

    const updatedProposal = {
      id,
      options: JSON.stringify(updatedOptions),
    }

    updateCampaignProposal(updatedProposal)
  }

  _renderEditingNavBar = () => {
    const { campaignProposal: { id } } = this.props
    const goBackUrl = `/agency/campaign_proposals/manage#/proposals/${id}/edit/digitalProposal`

    return (
      <div className={styles.editingNavBar}>
        <span className={styles.saveNotice}>Changes Saved Automatically</span>
        <a tabIndex="0" href={goBackUrl} className={styles.createButton}>
          Go Back
        </a>
      </div>
    )
  }

  render(){
    const {
      agents, artworks, brand, campaign, campaignComparables, campaignProposal, editing, images,
    } = this.props

    const marketComparables = filterComparables(campaignComparables, 'market')
    const agencyComparables = filterComparables(campaignComparables, 'agency')

    const disabled = disabledSections(campaignProposal)

    return (
      <div className={styles.root}>
        {editing && this._renderEditingNavBar()}

        <Header agents={agents} brand={brand} campaign={campaign} campaignProposal={campaignProposal} images={images} />

        <ToggleableSection
          editing={editing}
          enabled={!disabled.includes('welcome')}
          sectionId="welcome"
          title="Welcome!"
          toggleCallback={this._toggleSection}
        >
          <Welcome campaignProposal={campaignProposal} />
        </ToggleableSection>

        <ToggleableSection
          editing={editing}
          enabled={!disabled.includes('key-features')}
          sectionId="key-features"
          title="Key Features"
          toggleCallback={this._toggleSection}
        >
          <KeyFeatures campaign={campaign} />
        </ToggleableSection>

        <ToggleableSection
          editing={editing}
          enabled={!disabled.includes('buyer-profiles')}
          sectionId="buyer-profiles"
          title="Buyer Profiles"
          toggleCallback={this._toggleSection}
        >
          <BuyerProfiles campaign={campaign} />
        </ToggleableSection>

        <ToggleableSection
          editing={editing}
          enabled={!disabled.includes('campaign-quote')}
          sectionId="campaign-quote"
          title="Marketing Schedule"
          toggleCallback={this._toggleSection}
        >
          <CampaignQuotes brand={brand} campaignProposal={campaignProposal} />
        </ToggleableSection>

        <ToggleableSection
          editing={editing}
          enabled={!disabled.includes('download')}
          sectionId="download"
          title="Your Proposal"
          toggleCallback={this._toggleSection}
        >
          <Download brand={brand} artworks={artworks} campaignProposal={campaignProposal} images={images} />
        </ToggleableSection>

        <ToggleableSection
          editing={editing}
          enabled={!disabled.includes('comparables-market')}
          sectionId="comparables-market"
          title="Comparables"
          toggleCallback={this._toggleSection}
        >
          <Comparables brand={brand} campaign={campaign} campaignComparables={marketComparables} />
        </ToggleableSection>

        <ToggleableSection
          editing={editing}
          enabled={!disabled.includes('comparables-agency')}
          sectionId="comparables-agency"
          title="Our Properties"
          toggleCallback={this._toggleSection}
        >
          <Comparables brand={brand} campaign={campaign} campaignComparables={agencyComparables} />
        </ToggleableSection>

        <ToggleableSection
          editing={editing}
          enabled={!disabled.includes('campaign-timeline')}
          sectionId="campaign-timeline"
          title="Campaign Timeline"
          toggleCallback={this._toggleSection}
        >
          <Timeline campaign={campaign} />
        </ToggleableSection>

        <ToggleableSection
          editing={editing}
          enabled={!disabled.includes('price-recommendation')}
          sectionId="price-recommendation"
          title=""
          toggleCallback={this._toggleSection}
        >
          <PriceRecommendation campaignProposal={campaignProposal} />
        </ToggleableSection>

        <ToggleableSection
          editing={editing}
          enabled={!disabled.includes('contact')}
          sectionId="contact"
          title="When You're Ready"
          toggleCallback={this._toggleSection}
        >
          <Contact agents={agents} campaign={campaign} />
        </ToggleableSection>

        <RealhubFooter link="http://www.realhub.com.au/proposals" />
      </div>
    )
  }
}

RealhubMobile.propTypes = {
  artworks: PropTypes.object.isRequired,
  agents: PropTypes.object.isRequired,
  brand: PropTypes.object.isRequired,
  campaign: PropTypes.object.isRequired,
  campaignComparables: PropTypes.object,
  campaignProposal: PropTypes.object.isRequired,
  editing: PropTypes.bool,
  images: PropTypes.object.isRequired,
  updateCampaignProposal: PropTypes.func.isRequired,
}

function mapStateToProps(state, props){
  const { campaign } = props
  const { artworks } = state.entities

  return {
    artworks,
    campaignComparables: filteredObjectsSelector(state, 'campaignComparables', 'campaign_id', campaign.id),
  }
}

const mapDispatchToProps = {
  updateCampaignProposal: campaignProposalActions.updateCampaignProposal,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RealhubMobile)
